import { useIsAdmin } from '@edge/spark/io-roles'
import { customSearchCards, type DashboardCardDef } from '@edge/spark/io-dashboards'

export const isCardEditbleByUser = ({
    isAdmin,
    isReadOnly,
    isLocked,
}: {
    isAdmin: boolean
    isReadOnly: boolean
    isLocked: boolean
}): boolean => {
    if (isReadOnly) {
        return false
    }

    if (isLocked) {
        return isAdmin
    }

    return true
}

export const useIsCardEditbleByUser = (widgetDef: DashboardCardDef): boolean => {
    const customSearchCardConfig = customSearchCards.find((c) => widgetDef.type === c.type)
    // const hasCustomSearchCardConfig = !!customSearchCardConfig || false
    const isReadOnly = !!widgetDef.readOnly || customSearchCardConfig?.readOnly || false
    const isLocked = !!widgetDef.locked || customSearchCardConfig?.locked || false
    const isAdmin = useIsAdmin()

    const allowEditing = isCardEditbleByUser({
        isAdmin,
        isReadOnly,
        isLocked,
    })

    return allowEditing
}
